import React from 'react';
import PropTypes from 'prop-types';
import theme from 'theme/theme';
import styled from 'styled-components';

const StyledColumn = styled.th`
    position: relative;
    padding: 0;
    text-align: left;
    white-space: nowrap;
    text-transform: uppercase;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: 500;
    color: rgba(0,0,0,0.6);
    border-bottom: 1px solid ${ theme.table.head.border };

    &:first-of-type {
        padding-left: 12px;
    }
`;

const HeaderColumn = (props) => {
    const {
        children,
        style,
    } = props;

    return (
        <StyledColumn style={ style }>
            { children }
        </StyledColumn>
    );
};

HeaderColumn.propTypes = {
    children: PropTypes.node.isRequired,
    style: PropTypes.object,
};

export default HeaderColumn;



// WEBPACK FOOTER //
// ./src/components/ui/table/HeaderColumn.js